import * as React from 'react'
import PropTypes from 'prop-types'

const EWalletIcon = ({ width = 48, height = 42, color = '#101820' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 48 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_6629_40082)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M25.008 3.88A5.45 5.45 0 0020.16.94H5.44C2.437.94 0 3.351 0 6.323v29.35c0 2.972 2.437 5.385 5.44 5.385h14.72a5.443 5.443 0 005.1-3.511c.22-.584.34-1.215.34-1.873a.531.531 0 00-.534-.529.531.531 0 00-.533.529c0 .528-.096 1.037-.272 1.505a4.376 4.376 0 01-4.101 2.824H5.44c-2.414 0-4.373-1.94-4.373-4.329V6.324c0-2.39 1.96-4.328 4.373-4.328h14.72c1.7 0 3.174.961 3.898 2.366.134.26.454.362.717.23a.525.525 0 00.233-.71V3.88zm-7.941 31.9a2.123 2.123 0 00-2.134-2.112h-4.266c-1.178 0-2.134.946-2.134 2.111 0 1.166.956 2.113 2.134 2.113h4.266a2.124 2.124 0 002.134-2.113zM48 27.86h-8.64c-1.708 0-3.094-1.37-3.094-3.061v-3.378c0-1.69 1.386-3.063 3.094-3.063H48v-.844a2.33 2.33 0 00-1.644-2.217c.06-.296.056-.61-.028-.921L43.237 2.956a2.031 2.031 0 00-2.483-1.42L21.237 6.714a2.005 2.005 0 00-1.434 2.457l1.631 6.026a2.334 2.334 0 00-2.233 2.32v14.358c0 1.281 1.051 2.322 2.346 2.322h24.107c1.295 0 2.347-1.04 2.347-2.322V27.86H48zM20.967 5.691H3.733a.53.53 0 00-.533.528v25.338a.53.53 0 00.533.528h14.406a3.208 3.208 0 01-.006-.211V17.515c0-1.363.817-2.54 1.993-3.072l-1.353-5c-.442-1.632.538-3.313 2.188-3.75l.007-.002h-.001zM48 19.415v7.39h-8.64a2.017 2.017 0 01-2.027-2.006v-3.378c0-1.108.908-2.006 2.027-2.006H48zm-6.934 1.583c1.178 0 2.134.946 2.134 2.111a2.124 2.124 0 01-2.134 2.113 2.122 2.122 0 01-2.133-2.113c0-1.166.956-2.11 2.133-2.11zm2.271-13.59l-21.373 5.667.573 2.116h22.745a.928.928 0 00.015-.543l-1.96-7.24zm-2.481 3.117a.8.8 0 00-.98-.559l-2.601.69a.792.792 0 00-.565.97l.414 1.53a.8.8 0 00.98.56l2.602-.69a.79.79 0 00.565-.97l-.414-1.53h-.001zm1.652-6.176l-.303-1.122a.963.963 0 00-1.176-.671L21.51 7.733a.948.948 0 00-.678 1.163l.303 1.122 21.371-5.669.001.001z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_6629_40082">
          <path fill="#fff" transform="translate(0 .94)" d="M0 0H48V40.1194H0z" />
        </clipPath>
      </defs>
    </svg>
  )
}

EWalletIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  color: PropTypes.string,
}

export default React.memo(EWalletIcon)
